import CryptoJS from 'crypto-js'
import moment from 'moment/moment'

export default {
  data () {
    return {
      baseUrl: '',
      type: 'live'
    }
  },
  created: async function () {
    if (this.$root.account_type !== undefined) {
      if (this.$root.account_type !== '') {
        this.baseUrl = process.env.PROD_TYPE[this.$root.account_type].url
        this.type = this.$root.account_type
      } else {
        this.baseUrl = this.baseUrl = process.env.PROD_TYPE['demo'].url
        this.type = 'demo'
      }
    } else {
      this.baseUrl = this.baseUrl = process.env.PROD_TYPE['live'].url
      this.type = 'live'
    }
  },
  methods: {
    // fetchManageBookingData
    async fetchBookingData () {
      // set to searching
      this.isSearching = true
      const postData = {
        reference: this.reference,
        email_address: this.email,
        checkIfPaid: true
      }
      const postDataJson = JSON.stringify(postData)
      const authDetails = await this.getAuthentication()
      const encryptedData = this.CryptoJSAesEncrypt(authDetails.passkey, postDataJson)
      try {
        const formData = new FormData()
        formData.append('pid', this.propertyid)
        formData.append('consumer_key', authDetails.consumerKey)
        formData.append('data', encryptedData)
        formData.append('option', 'com_goreserva_psearch')
        formData.append('task', 'api.getBooking')
        const response = await this.axios.post(authDetails.posturl, formData)
        if (response) {
          // remove searching
          this.isSearching = false
          let data = this.CryptoJSAesDecrypt(authDetails.passkey, response.data.er)
          // close the modal
          this.closeModal()
          this.errors = JSON.parse(data).error
          if (!this.errors) {
            data = JSON.parse(data)
            const daysToCheckin = this.daysUntil(data.checkin_date)
            // dissalow edit if date is past
            if (moment(data.checkin_date).isBefore(moment(), 'day')) {
              this.errors = true
              this.$alert('Sorry, the booking with reference ' + data.reference_number + ' is a past booking and therefore cannot be edited', 'Edit Not Allowed!', 'error')
            } else if (data.guest_cancellation !== 0 && daysToCheckin < parseInt(data.guest_cancellation)) {
              this.errors = true
              const dayDays = data.guest_cancellation === '1' ? 'day' : 'days'
              this.$fire({
                title: 'Edit Not Allowed!',
                html: `Sorry, the booking with reference <strong>${data.reference_number}</strong> falls within our cancellation policy of <strong>${data.guest_cancellation} ${dayDays}</strong> before checkin`,
                type: 'error'
              })
            } else if (data.cancellation_status === '1') {
              this.errors = true
              this.$alert('Sorry, the booking with reference ' + data.reference_number + ' has already been cancelled', 'Edit Not Allowed!', 'error')
            } else {
              // end of dissallow edit
              this.$store.commit('updateBookingDetails', data)
              this.$router.push({
                path: `/manage-booking/?pid=` + btoa(this.propertyid),
                query: {
                  manage: 1
                }
              })
            }
          } else {
            this.errors = true
            this.$alert('Sorry, the details you entered do not match our records, please check and try again', 'Wrong Details!', 'error')
          }
        }
      } catch (error) {
        console.log('error', error)
      }
    },
    // end fetch Manage Booking Data
    async editBillingInfo () {
      const postData = {
        reference: this.bookingDetails.billing_details.reference,
        names: this.bookingData.billing_details.name,
        email_address: this.bookingData.billing_details.email,
        phone: this.bookingData.billing_details.phone,
        nationality: this.bookingData.billing_details.nationality
      }
      const postDataJson = JSON.stringify(postData)
      // get authentication
      const authDetails = await this.getAuthentication()
      const encryptedData = this.CryptoJSAesEncrypt(authDetails.passkey, postDataJson)
      try {
        const formData = new FormData()
        formData.append('pid', this.propertyid)
        formData.append('consumer_key', authDetails.consumerKey)
        formData.append('data', encryptedData)
        formData.append('option', 'com_goreserva_psearch')
        formData.append('task', 'api.updatePersonalDetails')
        const response = await this.axios.post(authDetails.posturl, formData)
        if (response) {
          let data = this.CryptoJSAesDecrypt(authDetails.passkey, response.data.er)
          this.errors = false
          this.errorMsg = []
          if (data !== '') {
            data = JSON.parse(data)
            if (data.success === 1) {
              this.showEdit = false
            }
          }
        }
      } catch (error) {
        console.log('error', error)
      }
    },
    async cancelBooking (val) {
      const postData = {
        booking_reference: this.$store.getters.bookingDetails.reference_number,
        email: this.$store.getters.bookingDetails.email,
        cancellation_reason: this.cancellation_reason ? this.cancellation_reason : val
      }
      const postDataJson = JSON.stringify(postData)
      // get authentication
      const authDetails = await this.getAuthentication()
      const encryptedData = this.CryptoJSAesEncrypt(authDetails.passkey, postDataJson)
      try {
        const formData = new FormData()
        formData.append('pid', this.propertyid)
        formData.append('consumer_key', authDetails.consumerKey)
        formData.append('posturl', authDetails.posturl)
        formData.append('data', encryptedData)
        formData.append('option', 'com_goreserva_psearch')
        formData.append('task', 'api.cancelBooking')
        const response = await this.axios.post(authDetails.posturl, formData)
        if (response) {
          let data = this.CryptoJSAesDecrypt(authDetails.passkey, response.data.er)
          this.errors = false
          this.errorMsg = []
          data = JSON.parse(data)
          if (data !== '' && data.cancelled === true) {
            this.$store.getters.bookingDetails.cancellation_status = 1
            this.$store.state.bookingCancelled = true
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    async editBookingDates () {
      // set to searching
      this.isSearching = true
      // check for availability
      await this.fetchData()
      this.$store.getters.bookingDetails.new_checkin_date = this.formatDatePicker(this.checkinDate)
      this.$store.getters.bookingDetails.new_checkout_date = this.formatDatePicker(this.dateOut)
      if (this.$store.getters.bookingDetails.nationality === '110') {
        this.$store.getters.bookingDetails.isResident = true
      } else {
        this.$store.getters.bookingDetails.isResident = false
      }

      const postData = {
        data: this.$store.getters.bookingDetails
      }
      const postDataJson = JSON.stringify(postData)
      // get authentication
      const authDetails = await this.getAuthentication()
      const encryptedData = this.CryptoJSAesEncrypt(authDetails.passkey, postDataJson)
      try {
        const formData = new FormData()
        formData.append('pid', this.propertyid)
        formData.append('consumer_key', authDetails.consumerKey)
        formData.append('data', encryptedData)
        formData.append('option', 'com_goreserva_psearch')
        formData.append('task', 'api.changeBookingDates')
        const response = await this.axios.post(authDetails.posturl, formData)
        if (response) {
          let data = response.data
          this.errors = false
          this.errorMsg = []
          this.isSearching = false
          if (data !== '') {
            this.dateChangeExtraPay = data
            this.$store.commit('updateEditDatesResponse', data)
          }
        }
      } catch (error) {
        console.log('error', error)
      }
    },
    editBookingDetails () {
      this.getUrlData()
      // specify modification is dates
      this.$store.getters.bookingDetails.modification_type = 'rooms'
      // end specify modification
      this.$router.push({
        path: `/?pid=` + btoa(this.roomDetails.property_id),
        query: {
          manage: 1
        }
      })
    },
    async saveDatesChanges () {
      this.$v.$touch()
      if (this.acceptedterm === true) {
        // update the same on the store
        const payload = {
          checkin_date: this.formatDatePicker(this.checkinDate),
          checkout_date: this.formatDatePicker(this.dateOut)
        }
        this.$store.commit('updateDates', payload)
        // update the session
        // with already existing details
        this.$store.state.room = this.selectedRoom[0]
        this.$store.state.board = this.singleBoard[0]
        // if proof of residence is blank
        // then default to isResident
        if (!this.$store.getters.bookingDetails.proof_of_residency) {
          this.$store.state.proofRes = 0
        } else {
          this.$store.state.proofRes = this.$store.getters.bookingDetails.isResident ? 0 : 1
        }
        // end proofRes
        this.$store.state.adults = parseInt(this.$store.getters.bookingDetails.details[0].adults)
        // specify modification is dates
        this.$store.getters.bookingDetails.modification_type = 'dates'
        // end specify modification
        this.$store.state.bookings = this.bookings
        // end of manage booking update
        // if refund required or no price change
        // just edit the dates for the booking
        if (this.dateChangeExtraPay.refundRequired || this.dateChangeExtraPay.noPriceChange) {
          let allData = this.$store.getters.bookingDetails
          const postData = {
            booking_reference: allData.reference_number,
            email_address: allData.email,
            old_checkin_date: allData.checkin_date,
            old_checkout_date: allData.checkout_date,
            new_checkin_date: allData.new_checkin_date,
            new_checkout_date: allData.new_checkout_date
          }
          const postDataJson = JSON.stringify(postData)          
          // get authentication
          const authDetails = await this.getAuthentication()
          const encryptedData = this.CryptoJSAesEncrypt(authDetails.passkey, postDataJson)
          try {
            const formData = new FormData()
            formData.append('pid', this.propertyid)
            formData.append('consumer_key', authDetails.consumerKey)
            formData.append('data', encryptedData)
            formData.append('option', 'com_goreserva_psearch')
            formData.append('task', 'api.changeBookingDetails')
            const response = await this.axios.post(authDetails.posturl, formData)
            if (response) {
              let data = this.CryptoJSAesDecrypt(authDetails.passkey, response.data.er)
              this.errors = false
              this.errorMsg = []
              data = JSON.parse(data)
              if (data !== '' && data.dateChanged) {
                // update the dates to show
                allData.checkin_date = postData.new_checkin_date
                allData.checkout_date = postData.new_checkout_date
                this.$alert('Dates changed successfully and an update email sent', '',
                  'success')
                // close the edit
                this.showEdit = false
              }
            }
          } catch (error) {
            console.log('error', error)
          }
        } else {
          // else, go to extra payments page
          this.$router.push({
            path: `/booking-detail/?pid=` + btoa(this.propertyid),
            query: {
              manage: 1
            }
          })
        }
      } else {
        this.$alert('Please accept the terms before proceeding.', '',
          'warning')
      }
    },
    daysUntil (date) {
      const now = moment()
      const future = moment(date)
      const duration = moment.duration(future.diff(now))
      return duration.asDays()
    },
    async getAuthentication () {
      try {
        const configUrl = process.env.CONFIG_URL['live_url']
        const key = process.env.PMS_KEY['key']
        const config = {
          headers: { 'Accept': 'application/json' }
        }
        const payload = {
          'property_id': this.propertyid,
          'api': this.type
        }
        const configRes = await this.$http.post(configUrl, payload, config)
        if (configRes.status === 200) {
          let configData = this.CryptoJSAesDecrypt(key, configRes.data.property_details)
          configData = JSON.parse(configData)
          const passkey = configData[0].val_ptoken// process.env.SECRET_KEY[this.propertyid].key
          let consumerKey = configData[0].val_reserveport_secret_key// process.env.CONSUMER_KEY[this.propertyid].key
          const details = JSON.parse(configData[0].add_details)
          let fetchUrl = details.url
          const posturl = `${fetchUrl}/index.php`
          const configDetails = {
            'passkey': passkey,
            'consumerKey': consumerKey,
            'posturl': posturl
          }
          return configDetails
        }
      } catch (error) {
        console.log(error)
      }
    },
    CryptoJSAesEncrypt (passphrase, plainData) {
      var salt = CryptoJS.lib.WordArray.random(256)
      var iv = CryptoJS.lib.WordArray.random(16)
      var key = CryptoJS.PBKDF2(passphrase, salt, {
        hasher: CryptoJS.algo.SHA512,
        keySize: 64 / 8,
        iterations: 999
      })

      var encrypted = CryptoJS.AES.encrypt(plainData, key, {
        iv: iv
      })

      var data = {
        ciphertext: CryptoJS.enc.Base64.stringify(encrypted.ciphertext),
        salt: CryptoJS.enc.Hex.stringify(salt),
        iv: CryptoJS.enc.Hex.stringify(iv)
      }
      // var encryptedDatajson = data
      return btoa(JSON.stringify(data))
    },
    CryptoJSAesDecrypt (passphrase, encryptedjsonstring) {
      let response = ''
      try {
        var objJson1 = atob(encryptedjsonstring)
        var objJson = JSON.parse(objJson1)

        var encrypted = objJson.ciphertext
        var salt = CryptoJS.enc.Hex.parse(objJson.salt)
        var iv = CryptoJS.enc.Hex.parse(objJson.iv)

        var key = CryptoJS.PBKDF2(passphrase, salt, {
          hasher: CryptoJS.algo.SHA512,
          keySize: 64 / 8,
          iterations: 999
        })

        var decrypted = CryptoJS.AES.decrypt(encrypted, key, {
          iv: iv
        })
        response = decrypted.toString(CryptoJS.enc.Utf8)
      } catch (error) {
        response = ''
      }
      return response
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/manageBooking.js